<div
  tabindex="0"
  class="prev-submissions-container {{ prevSubmissionsActive ? 'show' : '' }}">
  <div
    class="prev-submissions-title text-center d-flex align-items-center justify-content-between">
    <div class="ps-0 text-start"></div>
    <div>Previous Submissions</div>
    <div class="text-end pe-0">
      <i
        (click)="togglePrevSubmissions()"
        title="hide-icon"
        role="button"
        class="bi bi-arrow-bar-right me-2 p-2"></i>
    </div>
  </div>
  <div class="prev-submissions-body">
    <ng-container *ngIf="sessionSubmissionsData; else loadingTemplate">
      <ng-container *ngIf="sessionSubmissionsData.length > 0; else noData">
        <div class="pt-1 pb-3 px-2 fs-14 fst-italic">
          Preview all your previous submissions for the participant
        </div>
        <ng-container
          *ngFor="let session of sessionSubmissionsData; index as currentIndex">
          <div class="submission-item fs-11">
            <div class="content">
              <div
                class="submisison-item-title fs-16 fw-700 mb-1 color-link"
                (click)="showSubmissionModal(currentIndex)">
                {{ session.session.title }}
              </div>
              {{ session.session.start_datetime | formatDateMMDDYY }}
              <span class="fw-600 ms-2">{{ session.form.title }}</span>
            </div>
          </div>
        </ng-container>
      </ng-container>
      <ng-template #noData>
        <div class="fs-18xx p-3 text-center">
          No previous Observation & Feedback submissions for this participant
        </div>
      </ng-template>
    </ng-container>
    <ng-template #loadingTemplate>
      <div class="w-100 position-relative" style="height: 400px">
        <app-loader></app-loader>
      </div>
    </ng-template>
    <app-coaching-log-prev-submissions-modal
      *ngIf="sessionSubmissionsData"
      [sessionSubmissionsData]="sessionSubmissionsData"
      [currentSubmissionIdx]="selectedSessionSubIdx"
      #submissionModal />
  </div>
</div>
